import { render, staticRenderFns } from "./TableDeliveredPerCustomer.vue?vue&type=template&id=159da2bc&"
import script from "./TableDeliveredPerCustomer.vue?vue&type=script&lang=js&"
export * from "./TableDeliveredPerCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TableDeliveredPerCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports